import Api from '../Api'

export class ApiFin extends Api{

    constructor(){
        super()
    }

    async getMoedas(id=-1, dataInicial="", dataFinal="", empresa=""){
        return await super.get('moedas', id, dataInicial, dataFinal, empresa)
    }

    async saveLancamentoCaixa(obj){
        return await super.save('lancamento-caixa', obj)
    }
}